import { Control, useFieldArray, UseFormWatch } from 'react-hook-form'

import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import InvoiceLineFields from './InvoiceLineFields'
import { Button } from 'antd'
import './InvoiceLines.css'

interface InvoiceLinesFieldsProps {
  control: Control<InvoiceFormValues>
  watch: UseFormWatch<InvoiceFormValues>
}
const InvoiceLinesFields = ({ control, watch }: InvoiceLinesFieldsProps) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'invoice_lines',
  })

  return (
    <>
      <table className="invoice-lines-table">
        <thead>
          <tr>
            <th className="p-2 product-column">Product</th>
            <th className="p-2">Unit</th>
            <th className="p-2">Unit Price</th>
            <th className="p-2">Tax Rate</th>
            <th className="p-2">Unit Tax Price</th>
            <th className="p-2">Quantity</th>
            <th className="p-2">Total Price</th>
            <th className="p-2">Total Tax</th>
            <th className="p-2"></th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field, index) => (
            <tr key={field.id} className="border-b">
              <InvoiceLineFields
                control={control}
                index={index}
                onRemove={() => remove(index)}
                watch={watch}
              />
            </tr>
          ))}
        </tbody>
      </table>
      <Button
        type="primary"
        className="mt-4"
        onClick={() => append({ product: null, quantity: 0 })}
      >
        Add Line
      </Button>
    </>
  )
}

export default InvoiceLinesFields
